import React, { memo } from "react";
import {
	Row, Col,
	Card, CardBody,
	Button
} from "reactstrap";
import { NavLink } from "react-router-dom";

const TestFinishedDueToTimeout = memo( function TestFinishedDueToTimeout() {

	return (
		<div className="content questionsArea deviceTestPage">
			<Row>
				<Col xs={12}>
					<Card>
						<CardBody className="test-finished-message">
							<Row className='unselectable'>
								<div className="row">
									<div className="mt-0 col-12">
										<h4>Test stopped due to timeout.</h4>
									</div>
									<div className="mt-0 row">
										<div className="col-md-3 col-sm-0"></div>
										<div className="col-md-3 col-sm-6">
											<NavLink to={'/admin/dashboard'}>
												<Button block className="text-center">Go to Dashboard</Button>
											</NavLink>
										</div>
										<div className="col-md-3 col-sm-6">
											<NavLink to={'/admin/mock-result'}>
												<Button block className="text-center">See Results</Button>
											</NavLink>
										</div>
										<div className="col-md-3 col-sm-0"></div>
									</div>
								</div>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default TestFinishedDueToTimeout;